// extracted by mini-css-extract-plugin
export default {"charsWrapper":"BusinessChars_charsWrapper__Q8X6U"};